import { PumsemManageLayoutView } from '@/features/pumsem/manage';
import { ScrollToTop } from '@/app/layouts/utils/ScrollToTop.tsx';
import { RouteLoadingOverlay } from '@/app/layouts/utils/RouteLoadingOverlay.tsx';

/**
 * `/pumsem/manage/*` 레이아웃.
 *
 * `MainLayout` 을 쓰지 않는다 — 마케팅 헤더의 메가메뉴가 편집 폼 위로 펼쳐지고,
 * 사업자 정보 푸터가 저장 버튼 아래에 한 뭉치 붙는다. 관리도 품셈해설의 일부라
 * 헤더·푸터가 열람 화면과 같은 계열이어야 한다.
 */
export default function PumsemManageLayout() {
  return (
    <>
      <ScrollToTop />
      <RouteLoadingOverlay />
      <PumsemManageLayoutView />
    </>
  );
}
